import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { FeatureMatrix } from '@/components/feature-matrix'

import { SectionHeading } from './elements'
import { Plans, useFeatures } from './pricing-plans'

const ComparePlansSection = styled.section``

type FeaturesProps = {
  plans: Plans
}

const FeaturesSection: React.FC<FeaturesProps> = ({ plans }) => {
  const { t } = useTranslation('pricing')
  const features = useFeatures()
  const planNames = plans.map(plan => ({ key: plan.value, value: plan.name }))
  return (
    <ComparePlansSection>
      <SectionHeading>{t('pricing:Compare plans & features')}</SectionHeading>
      {features.map(feature => (
        <FeatureMatrix
          key={`feature-matrix-${feature.key}`}
          plans={planNames}
          feature={feature}
        />
      ))}
    </ComparePlansSection>
  )
}

export default FeaturesSection
